import { userPrivacySetting } from '@/Models';
import { consentManager } from './ConsentManager';
import { analyticsPluginName } from '@/Utils/AnalyticsUtility';
import { loadScript } from '@/Utils/ScriptUtility';
import Log from '@/Utils/Log';

const FB_STANDARD_EVENTS = new Set([
    'AddPaymentInfo', 'AddToCart', 'AddToWishlist', 'CompleteRegistration',
    'Contact', 'CustomizeProduct', 'Donate', 'FindLocation', 'InitiateCheckout',
    'Lead', 'PageView', 'Purchase', 'Schedule', 'Search', 'StartTrial',
    'SubmitApplication', 'Subscribe', 'ViewContent',
]);

/**
 * @param {object} analyticsConfig - analyticsConfig from InitialState
 */
export default function facebookPlugin(analyticsConfig) {
    if (!window.fbq) {
        const fbq = function() {
            if (fbq.callMethod) {
                fbq.callMethod.apply(fbq, arguments);
            }
            else {
                fbq.queue.push(arguments);
            }
        };
        fbq.push = fbq;
        fbq.loaded = false;
        fbq.version = '2.0';
        fbq.queue = [];
        window.fbq = fbq;
    }
    window._fbq = window._fbq || window.fbq;
    window.facebookPixels = window.facebookPixels || [];

    let loaded = false;

    consentManager.register(analyticsPluginName.facebookPixel, userPrivacySetting.marketing, () => {
        loaded = true;

        loadScript('https://connect.facebook.net/en_US/fbevents.js').catch((error) => {
            Log.warn('[FacebookPlugin] Failed to load fbevents.js', error);
        });

        const { pixelID, pixelIDV2 } = analyticsConfig.facebookPixel;
        const externalAnalytics = analyticsConfig.externalAnalytics;
        const user = analyticsConfig.user;

        if (pixelID) {
            window.facebookPixels.push({ code: pixelID, shouldTrackEvents: true });
            window.fbq('init', pixelID);
        }

        if (pixelIDV2) {
            window.facebookPixels.push({ code: pixelIDV2, shouldTrackEvents: false });
            const initData = {};

            if (user) {
                initData.em = user.email;
                initData.external_id = user.userId;
            }

            window.fbq('init', pixelIDV2, initData);
        }

        if (externalAnalytics?.facebookPixelId && !externalAnalytics.isMetaConversionApiEnabled) {
            window.facebookPixels.push({ code: externalAnalytics.facebookPixelId, shouldTrackEvents: true });
            window.fbq('init', externalAnalytics.facebookPixelId);
        }

        window.fbq('track', 'PageView');
    });

    return {
        name: analyticsPluginName.facebookPixel,
        config: analyticsConfig,
        track: () => {},
        trackTo: ({ event, properties }) => {
            if (!loaded) return;
            const pixels = window.facebookPixels
                .filter(p => p.shouldTrackEvents)
                .map(p => p.code);
            const method = FB_STANDARD_EVENTS.has(event) ? 'trackSingle' : 'trackSingleCustom';
            for (const pixelId of pixels) {
                window.fbq(method, pixelId.toString(), event, properties);
            }
        },
    };
}
